const $ = jQuery.noConflict();

'use strict';
const Header = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domHeader: $('.site-header'),
	$headerMenu: $('.site-header__menu'),
	classHeaderScroll: 'is-sticky',
	$toggleUserDropdown: $('.js-toggle-user-dropdown'),
	$userDropdown: $('.js-user-dropdown'),

	$announcementBanner: $('.js-announcement-banner'),
	$announcementClose: $('.js-announcement-close'),

	/** @description Initialize */
	init: function() {
		this.headerScroll();
		this.headerStickyOnLoad();
		this.showMenuOnLoad();
		this.userDropdownToggle();
		this.announcementBanner();
	},

	headerScroll: function() {
		$(document).on('scroll', function() {
			const scrollTop = $(document).scrollTop();
			if(scrollTop > 20) {
				Header.$domHeader.addClass(Header.classHeaderScroll);
			} else {
				Header.$domHeader.removeClass(Header.classHeaderScroll);
			}
		});
	},

	headerStickyOnLoad: function() {
		$(window).on('load', function() {
			const scrollTop = $(document).scrollTop();
			if(scrollTop > 20) {
				Header.$domHeader.addClass(Header.classHeaderScroll);
			} else {
				Header.$domHeader.removeClass(Header.classHeaderScroll);
			}
		});
	},

	showMenuOnLoad: function() {
		$(window).on('load', function() {
			Header.$headerMenu.css('display', 'block');
		});
	},

	announcementBanner: function() {
		if (!this.$announcementBanner.length) return;

		this.$announcementClose.on('click', function() {
			const bannerHeight = Header.$announcementBanner.outerHeight(true);
			const currentPadding = parseInt($('body').css('padding-top'), 10);

			Header.$announcementBanner.slideUp(300);
			$('body').animate({paddingTop: currentPadding - bannerHeight}, 300);

			sessionStorage.setItem('announcementClosed', 'true');
			document.documentElement.classList.add('announcement-closed');
		});
	},

	/** @description Toggle user dropdown */
	userDropdownToggle: function() {
		if(!this.$toggleUserDropdown.length || !this.$userDropdown.length) return;

		this.$toggleUserDropdown.on('click', function(e) {
			e.preventDefault();
			Header.$userDropdown.stop(true, true).slideToggle(200);
		});

		// close dropdown when click outside
		$(document).on('click', function(e) {
			if (!Header.$toggleUserDropdown.is(e.target) && Header.$toggleUserDropdown.has(e.target).length === 0 &&
				!Header.$userDropdown.is(e.target) && Header.$userDropdown.has(e.target).length === 0) {
				Header.$userDropdown.slideUp(200);
			}
		});
	}
};

export default Header;